import { useQuery } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

export function useGetProjectNextStepRecommendationQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project", project?.id, "next-step-suggestion"],
        queryFn: async () => {
            const res = await apiClient.getProjectNextStepsRecommendation({
                params: {
                    projectId: project.id,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to get project next step recommendation");
            }
            return res.body.text;
        },
    });
}
